var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9004 11.6C23.7004 11.2 19.5004 3 12.0004 3C4.50039 3 0.300391 11.2 0.100391 11.6C0.000390626 11.9 0.000390626 12.2 0.100391 12.5C0.300391 12.8 4.50039 21 12.0004 21C19.5004 21 23.7004 12.8 23.9004 12.4C24.0004 12.2 24.0004 11.8 23.9004 11.6ZM12.0004 19C6.60039 19 3.10039 13.6 2.10039 12C3.00039 10.4 6.60039 5 12.0004 5C17.4004 5 20.9004 10.4 21.9004 12C20.9004 13.6 17.4004 19 12.0004 19ZM12.0004 8C9.80039 8 8.00039 9.8 8.00039 12C8.00039 14.2 9.80039 16 12.0004 16C14.2004 16 16.0004 14.2 16.0004 12C16.0004 9.8 14.2004 8 12.0004 8ZM12.0004 14C10.9004 14 10.0004 13.1 10.0004 12C10.0004 10.9 10.9004 10 12.0004 10C13.1004 10 14.0004 10.9 14.0004 12C14.0004 13.1 13.1004 14 12.0004 14Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconEye.b451d3596d5d99f595b87e1f94512ab6.svg";